export const conditionTypes = {
  twrDevices: 'Device',
  zwaveDevices: 'Device',
  userTrigger: 'UserTrigger',
}
export const deviceType = {
  twrDevices: 'twr_device',
  zwaveDevices: 'zwave_device',
}
